import styled, { keyframes } from "styled-components";

const fadeIn = keyframes`
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
`;

const iconPopIn = keyframes`
    0% { transform: scale(0); }
    80% { transform: scale(1.1); }
    100% { transform: scale(1); }
`;

export const Container = styled.div`
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    background-color: #f0f2f5;
    background-image: url('/textura.jpg');
    background-size: cover;
`;

export const BoxCenter = styled.div`
    width: 100%;
    max-width: 450px;
    background-color: #ffffff;
    padding: 2.5rem 3rem;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    align-items: center;
    animation: ${fadeIn} 0.5s ease-out;
`;

export const Logo = styled.img`
    width: 120px;
    margin-bottom: 2rem;
`;

export const Title = styled.h2`
    font-size: 1.6rem;
    color: #333;
    margin-bottom: 0.75rem;
    text-align: center;
    font-weight: 600;
`;

export const Subtitle = styled.p`
    font-size: 1rem;
    color: #666;
    text-align: center;
    margin-bottom: 2rem;
    line-height: 1.5;
`;

export const Form = styled.form`
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const InputWrapper = styled.div`
    position: relative;
    width: 100%;
    margin-bottom: 1.5rem;
`;

export const Icon = styled.div`
    position: absolute;
    top: 50%;
    left: 15px;
    transform: translateY(-50%);
    color: #aaa;
    font-size: 1.1rem;
`;

export const Input = styled.input`
    width: 100%;
    height: 50px;
    padding: 0 15px 0 45px;
    box-sizing: border-box;
    border: 1px solid #ddd;
    border-radius: 8px;
    font-size: 1rem;
    transition: border-color 0.3s, box-shadow 0.3s;

    &:focus {
        outline: none;
        border-color: #b17d2a;
        box-shadow: 0 0 0 3px rgba(177, 125, 42, 0.2);
    }
`;

export const SubmitButton = styled.button`
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 8px;
    background: linear-gradient(90deg, #b17d2a, #e6aa11);
    color: white;
    font-size: 1rem;
    font-weight: bold;
    cursor: pointer;
    transition: opacity 0.3s, transform 0.2s;

    &:disabled {
        opacity: 0.6;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        opacity: 0.9;
    }
`;

export const Message = styled.p`
    text-align: center;
    margin-top: 1.5rem;
    padding: 0.75rem;
    border-radius: 8px;
    background-color: ${props => (props.isSuccess ? '#e9f7ef' : '#fbe9e9')};
    color: ${props => (props.isSuccess ? '#1e7e34' : '#c82333')};
    font-weight: 500;
    animation: ${fadeIn} 0.3s;
`;

export const AlternativeLink = styled.span`
    margin-top: 1.5rem;
    color: #555;
    cursor: pointer;
    font-size: 0.9rem;
    
    &:hover {
        text-decoration: underline;
        color: #b17d2a;
    }
`;

export const SuccessContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: ${fadeIn} 0.5s ease-out;
`;

export const SuccessIcon = styled.div`
    font-size: 4rem;
    color: #28a745;
    margin-bottom: 1rem;
    animation: ${iconPopIn} 0.5s ease-out;
`;

export const BackButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1.5rem;
    padding: 0.75rem 1.5rem;
    background: none;
    border: 1px solid #ddd;
    color: #555;
    border-radius: 8px;
    font-size: 0.9rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
        background-color: #f8f9fa;
        color: #333;
        border-color: #ccc;
    }
`;